module.exports = __webpack_public_path__ + "img/camp_shirt_other1.a53d71da.svg";